module.exports = __webpack_public_path__ + "img/center-silver.25880809.png";